import React from "react";
import "./ExperienceSec6.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { handleContactRedirect } from "../../handleContactRedirect";

export const ExperienceSec6 = () => {
  const navigate = useNavigate();

  return (
   <div className="standard-padding">
      {/* DESKTOP VIEW */}
      <div className="experiencesec6 desktop-view">
        <div className="experiencesec6-container">
          <h1 className="heading">Travel With Peace of Mind</h1>
          <p className="text">
            At Blueberry DMC, our strength lies in being truly on the ground. We
            work directly with local suppliers, transport providers, and hotels,
            cutting out intermediaries entirely. This gives our partners
            transparent pricing, faster confirmations, and dependable operations
            across every destination we serve. Our regional teams understand
            local market behavior, seasonality, and traveler expectations,
            equipping you with the insight needed to design products that
            actually sell. Partner with us to combine authentic on-ground
            experiences with the operational reliability that drives real
            business growth.
          </p>
          <Button
            className="experiencesec6-button"
            onClick={() => handleContactRedirect(navigate)}
          >
            Plan Your Next Itinerary
          </Button>
        </div>
        <img
          className="experiencesec6-img"
          src="https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/plan-bg.webp"
          alt="img"
        />
      </div>

      {/* MOBILE VIEW */}
      <div className="experiencesec6 mobile-view">
        <h1 className="heading">Travel With Peace of Mind</h1>
        <p className="text">
          At Blueberry DMC, our strength lies in being truly on the ground. We
          work directly with local suppliers, transport providers, and hotels,
          cutting out intermediaries entirely. This gives our partners
          transparent pricing, faster confirmations, and dependable operations
          across every destination we serve. Our regional teams understand
          local market behavior, seasonality, and traveler expectations,
          equipping you with the insight needed to design products that
          actually sell. Partner with us to combine authentic on-ground
          experiences with the operational reliability that drives real
          business growth.
        </p>
        <img
          className="experiencesec6-img"
          src="https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/plan-bg.webp"
          alt="img"
        />
        <Button
          className="experiencesec6-button"
          onClick={() => handleContactRedirect(navigate)}
        >
          Plan Your Next Itinerary
        </Button>
      </div>
    </div>
  );
};